import {writable} from 'svelte/store';
import Login from '../Components/Login.svelte';
import Empty from '../Components/Empty.svelte';
import AgentComponent from '../Components/Agent.svelte';
import Dashboard from '../Components/Dashboard.svelte';
import Contact from '../Components/Contact.svelte';
import Conference from '../Components/Conference.svelte';
import ConferenceList from '../Components/Conference/List.svelte';
import ContactList from '../Components/Contact/List.svelte';
import Settings from '../Components/Settings.svelte';
import Helper from '../Models/Helper';
import Session from './Session';
import Agent from './Agent';

const tags = {
	'login': Login,
	'empty': Empty,
	'dashboard': Dashboard,
	'contact': Contact,
	'agent': AgentComponent,
	'conference': Conference,
	'conference_list': ConferenceList,
	'contact_list': ContactList,
	'settings': Settings,
};

const content = {code: 'empty', component: Empty, data: {}, history: {}};

try {
	const json = window.localStorage.getItem('history');
	if (json) {
		const history = JSON.parse(json);
		content.history = history;
	}
}
catch (error) { }

let router = writable(content);

router.subscribe(state => {
	try {
		const json = JSON.stringify(state.history);
		window.localStorage.setItem('history', json);
	}
	catch (error) { }
});

router.empty = () => {
	content.code = 'empty';
	content.component = tags[content.code];
	content.data = {};
	router.set(content);
};

router.component = (code, data) => {
	const component = tags?.[code];
	if (component) {
		const same = content.code === code;
		if (same) router.empty();

		const proceed = () => {
			let tag = code;
			if (Helper.is(data)) {
				const data_json = JSON.stringify(data);
				const data_hex = btoa(data_json);
				tag += `-${data_hex}`;
			}

			content.code = code;
			content.component = component;
			content.data = data || {};
			content.history[tag] = content.data;
			router.set(content);

			window.location.hash = tag;
		};

		if (same) setTimeout(proceed, 100);
		else proceed();
	}
};

function init() {
	const authenticated = Session.isAuthenticated();
	let tag = window.location.hash.substring(1);
	if((tag == 'login' || !tag) && authenticated)
		tag = 'dashboard';
	else if(!authenticated)
		tag = false;

	if (tag) {
		const code = tag.match(/^([^\-]+)/)[1];
		const data = content.history?.[tag] || {};
		router.component(code, data);
		Agent.init();
	}
	else router.component('login');
}

init();

export default router;
